import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedGroup } from '../redux/slices/globalSlice';

const useSelectedGroup = (groupOptions, selectedCompanyId) => {
    const { selectedGroup } = useSelector((state) => state.global);
    const dispatch = useDispatch();

    const [group, setGroup] = useState(selectedGroup || '');

    const isValidGroup = groupOptions.some((option) => option._id === group);
    const safeSelectedGroup = isValidGroup ? group : groupOptions[0]?._id || '';

    const handleGroupChange = useCallback(
        (event) => {
            const newGroup = event.target.value;
            setGroup(newGroup);
            dispatch(setSelectedGroup(newGroup));
        },
        [dispatch]
    );

    useEffect(() => {
        if (groupOptions.length > 0) {
            const initialGroup = selectedGroup || groupOptions[0]._id;
            setGroup(initialGroup);
            dispatch(setSelectedGroup(initialGroup));
        }
    }, [groupOptions, selectedCompanyId, dispatch, selectedGroup]);

    useEffect(() => {
        if (groupOptions.length > 0) {
            const groupExists = groupOptions.find((option) => option._id === group);
            if (!groupExists) {
                const fallbackGroup = groupOptions[0]._id;
                setGroup(fallbackGroup);
                dispatch(setSelectedGroup(fallbackGroup));
            }
        }
    }, [groupOptions, selectedCompanyId, group, dispatch]);

    return {
        selectedGroup: safeSelectedGroup,
        handleGroupChange,
    };
};

export default useSelectedGroup;
